import { useState } from 'react';

export const useDisclaimerForm = () => {
  const [openBackgroundDrawer, setOpenBackgroundDrawer] = useState(false);
  const [OpenDisclaimerDrawer, setOpenDisclaimerDrawer] = useState(false);

  const onToggleBackgroundDrawer = () =>
    setOpenBackgroundDrawer(!openBackgroundDrawer);

  const onToggleDisclaimerDrawer = () =>
    setOpenDisclaimerDrawer(!OpenDisclaimerDrawer);

  return {
    openBackgroundDrawer,
    OpenDisclaimerDrawer,
    onToggleBackgroundDrawer,
    onToggleDisclaimerDrawer,
  };
};
